export const workflowDefaultPermissions: { [permission: string]: string[] } = {
  Edit: ["Admin", "Manager"],
  Delete: ["Admin", "Manager"],
  "Force State Change": ["Admin", "Manager"],
  Move: ["Admin", "Manager"],
  Prioritize: ["Admin", "Manager"],
  "View History": ["Admin", "Manager"],
  "Can Transition": ["Admin", "Manager"]
};
